<template>
  <div id="print-house-wrapper">
    <v-app>
      <v-content>
        <v-container>
          <v-row class="text-left">
            <v-col cols="12">
              <v-btn
                color="primary"
                dark
                @click.stop="modalVisible = !modalVisible"
                v-if="appEnabled"
              >{{ "Добавить типографию" }}</v-btn>
              <v-alert
                dismissible
                elevation="4"
                type="success"
                v-if="!appEnabled"
              >
                Ваша заявка отправлена на модерацию, будет рассмотрена и размещена на сайте
                после подтверждения вами электронного адреса. Для этого на указанный в заявке Email отправлено письмо.
              </v-alert>

              <v-dialog
                v-model="modalVisible"
                max-width="780px"
                scrollable
                :fullscreen="isMobile"
              >
                <v-card>
                  <v-card-title class="headline primary white--text">
                    Добавить типографию
                  </v-card-title>
                  <v-card-text style="border-bottom: 1px solid rgba(0,0,0,0.2)" class="pb-0">
                    <v-container>
                      <v-row>
                        <v-col cols="12" sm="12" md="12" lg="12">
                          <dadata-combobox type="party" @hasChanged="nameChanged" ref="companyAutocomplete"></dadata-combobox>
                        </v-col>
                        <v-col cols="12" sm="12" md="12" lg="12" class="pt-0">
                          <dadata-autocomplete type="address" @hasChanged="addressChanged" ref="addressAutocomplete"></dadata-autocomplete>
                        </v-col>
                        <v-col cols="12" sm="12" md="12" lg="12" class="pt-0">
                          <v-text-field
                            label="Сайт"
                            v-model="item.website"
                            persistent-hint
                            clearable
                            @blur="$v.item.website.$touch()"
                            :error-messages="errorMessages('website')"
                            dense
                          ></v-text-field>
                        </v-col>
                        <v-col cols="12" sm="6" md="6" lg="6" class="pt-0">
                          <v-text-field
                            label="Email"
                            v-model="item.infoEmail"
                            persistent-hint
                            clearable
                            @blur="$v.item.infoEmail.$touch()"
                            :error-messages="errorMessages('infoEmail')"
                            dense
                          ></v-text-field>
                        </v-col>
                        <v-col cols="12" sm="6" md="6" lg="6" class="pt-0">
                          <v-text-field
                            label="Телефон"
                            v-model="item.infoPhone"
                            persistent-hint
                            clearable
                            @blur="$v.item.infoPhone.$touch()"
                            :error-messages="errorMessages('infoPhone')"
                            dense
                          ></v-text-field>
                        </v-col>
                        <v-col cols="12" sm="12" md="12" lg="12" class="pt-0">
                          <v-select
                          :items="specializationsList"
                          multiple
                          chips
                          small-chips
                          deletable-chips
                          clearable
                          v-model="item.specializations"
                          label="Профили вашей типографии"
                          hint="выберете из списка подходящее"
                          persistent-hint
                          @blur="$v.item.specializations.$touch()"
                          :error-messages="errorMessages('specializations')"
                          dense
                          ></v-select>
                        </v-col>
                        <v-col cols="12" sm="12" md="12" lg="12" >
                          <v-textarea
                            label="Печатное оборудование"
                            hint="Перечислите через запятую"
                            persistent-hint
                            v-model="item.printEquipment"
                            rows="2"
                            clearable
                            dense
                            outlined
                          ></v-textarea>
                        </v-col>
                        <v-col cols="12" sm="12" md="12" lg="12" class="pt-0">
                          <v-textarea
                            label="Послепечатное оборудование"
                            hint="Перечислите через запятую"
                            persistent-hint
                            v-model="item.postprintEquipment"
                            rows="2"
                            clearable
                            dense
                            outlined
                          ></v-textarea>
                        </v-col>
                        <v-col cols="12" sm="12" md="12" lg="12" class="pt-0 pb-0">
                          <v-row>
                            <v-col cols="12" sm="12" md="12" lg="12" style="margin: 0px;padding: 0px 0px 0px 12px; margin-bottom: -25px">
                              <p class="title">Контакты ответственного лица*</p>
                            </v-col>
                            <v-col cols="12" sm="6" md="6" lg="6">
                              <v-text-field
                                label="Имя"
                                v-model="item.contactName"
                                persistent-hint
                                clearable
                                @blur="$v.item.contactName.$touch()"
                                :error-messages="errorMessages('contactName')"
                                dense
                              ></v-text-field>
                            </v-col>
                            <v-col cols="12" sm="6" md="6" lg="6">
                              <v-text-field
                                label="Фамилия"
                                v-model="item.contactSurname"
                                persistent-hint
                                clearable
                                @blur="$v.item.contactSurname.$touch()"
                                :error-messages="errorMessages('contactSurname')"
                                dense
                              ></v-text-field>
                            </v-col>
                            <!--
                            <v-col cols="12" sm="6" md="4" lg="4">
                              <v-text-field
                                label="Отчество (при наличии)"
                                v-model="item.contactLastname"
                                hint="Укажите отчество"
                                persistent-hint
                                clearable
                              ></v-text-field>
                            </v-col>
                            -->
                            <v-col cols="12" sm="6" md="6" lg="6" class="pt-0">
                              <v-text-field
                                label="Email"
                                v-model="item.contactEmail"
                                persistent-hint
                                clearable
                                @blur="$v.item.contactEmail.$touch()"
                                :error-messages="errorMessages('contactEmail')"
                                dense
                              ></v-text-field>
                            </v-col>
                            <v-col cols="12" sm="6" md="6" lg="6" class="pt-0">
                              <v-text-field
                                label="Телефон"
                                v-model="item.contactPhone"
                                persistent-hint
                                clearable
                                dense
                              ></v-text-field>
                            </v-col>
                            <v-col cols="12" sm="12" md="12" lg="12" class="pt-0 pb-0">
                              <p class="subheading">
                                * Эти данные мы не будем публиковать, они нужны только для связи
                              </p>
                              <v-checkbox
                                v-model="personalPolicyApprooved"
                              >
                                <template v-slot:label>
                                  <div>
                                    Я прочитал и даю согласие/гарантирую получение согласия от контактного лица на
                                    <a @click.stop href="https://www.osp.ru/personalpolicy/" target="_blank"> обработку персональных данных.</a>
                                  </div>
                                </template>
                              </v-checkbox>
                            </v-col>
                            <!--
                            <v-col cols="12" sm="6" md="4" lg="4">
                              <v-text-field
                                label="Должность контактного лица"
                                v-model="item.contactPosition"
                                persistent-hint
                                hint="Укажите должность"
                                clearable
                                @blur="$v.item.contactPosition.$touch()"
                                :error-messages="errorMessages('contactPosition')"
                              ></v-text-field>
                            </v-col>
                            -->
                          </v-row>
                        </v-col>

                      </v-row>
                    </v-container>
                  </v-card-text>
                  <v-card-actions class="blue-grey lighten-5">
                    <v-spacer></v-spacer>
                    <v-btn color="error" @click.stop="clearEverything">Очистить все поля</v-btn>
                    <v-btn color="error" @click.stop="modalVisible = false">Отмена</v-btn>
                    <v-btn
                      color="info"
                      @click.stop="sendForm"
                      :disabled="!isEverythingValid"
                    >Отправить заявку</v-btn>
                  </v-card-actions>
                </v-card>
              </v-dialog>
              <v-snackbar
                v-model="bottomAlert.visible"
                bottom
                :color="bottomAlert.color"
                :right="bottomAlert.right"
                :timeout="bottomAlert.timeout"
              >
                {{ bottomAlert.alertText }}
                <v-btn
                  @click="bottomAlert.visible = false"
                  dark
                  text
                >
                  Закрыть
                </v-btn>
              </v-snackbar>
            </v-col>
          </v-row>
        </v-container>
      </v-content>
    </v-app>
  </div>
</template>

<script>

import Vue from 'vue'
import { isMobile } from 'mobile-device-detect'
import axios from 'axios'
import Qs from 'qs'
import DadataAutocomplete from './components/DadataAutocomplete.vue'
import DadataCombobox from './components/DadataCombobox.vue'
import { required, email, url } from 'vuelidate/lib/validators'

const backendAxios = axios.create({})
// eslint-disable-next-line no-undef
backendAxios.defaults.baseURL = backendUrl

backendAxios.interceptors.request.use(config => {
  config.paramsSerializer = params => {
    return Qs.stringify(params, {
      arrayFormat: 'brackets',
      encode: false
    })
  }
  return config
})

const apiAxios = axios.create({})
// eslint-disable-next-line no-undef
apiAxios.defaults.baseURL = apiUrl + '/print-house/'

apiAxios.interceptors.request.use(config => {
  config.paramsSerializer = params => {
    return Qs.stringify(params, {
      arrayFormat: 'brackets',
      encode: false
    })
  }
  return config
})

export default {
  name: 'App',

  components: {
    DadataAutocomplete,
    DadataCombobox
  },

  data: () => ({
    btnHovered: false,
    appEnabled: false,
    modalVisible: false,
    personalPolicyApprooved: false,
    isMobile,
    specializationsList: [],
    item: {
      name: null,
      website: null,
      federalDistrict: null,
      region: null,
      city: null,
      postAddress: null,
      fullAddress: null,
      fiasId: null,
      fiasCode: null,
      kladrId: null,
      location: {
        type: 'Point',
        coordinates: []
      },
      contactSurname: null,
      contactName: null,
      contactLastname: null,
      contactPosition: null,
      contactPhone: null,
      contactEmail: null,
      specializations: null,
      printEquipment: null,
      postprintEquipment: null
    },
    errMessages: {
      required: ' ',
      email: 'Требуется корректный email',
      url: 'Требуется корректный URL адрес(https://...)'
    },
    bottomAlert: {
      visible: false,
      alertText: '',
      color: 'cyan darken-2', // success info error
      timeout: 6000,
      right: true
    }
  }),
  validations: {
    item: {
      contactSurname: {
        required: required
      },
      contactName: {
        required: required
      },
      // contactPosition: {
      //   required: required
      // },
      specializations: {
        required: required
      },
      contactEmail: {
        required: required,
        email: email
      },
      infoEmail: {
        required: required,
        email: email
      },
      infoPhone: {
        required: required
      },
      website: {
        url: url
      }
    }
  },
  computed: {
    isEverythingValid () {
      const addrIsOk = this.$refs.addressAutocomplete ? !this.$refs.addressAutocomplete.$v.$invalid : false
      const companyIsOk = this.$refs.companyAutocomplete ? !this.$refs.companyAutocomplete.$v.$invalid : false
      return !this.$v.$invalid && addrIsOk && companyIsOk && this.personalPolicyApprooved
    }
  },
  methods: {
    errorMessages (itemFieldName) {
      const errorsList = []
      const validateData = this.$v.item[itemFieldName]
      if (!validateData.$dirty) {
        return []
      }

      var isRequiredValidatorExist = Object.prototype.hasOwnProperty.call(validateData, 'required')
      if (isRequiredValidatorExist && !validateData.required) {
        errorsList.push(this.errMessages.required)
      }

      var isEmailValidatorExist = Object.prototype.hasOwnProperty.call(validateData, 'email')
      if (isEmailValidatorExist && !validateData.email) {
        errorsList.push(this.errMessages.email)
      }

      var isUrlValidatorExist = Object.prototype.hasOwnProperty.call(validateData, 'url')
      if (isUrlValidatorExist && !validateData.url) {
        errorsList.push(this.errMessages.url)
      }

      return errorsList
    },
    sendForm () {
      apiAxios.put('add', this.item)
        .then((response) => {
          console.log(response)
          if (!response.data.success && response.data.errors) {
            const errList = Object.entries(response.data.errors).reduce(function (res, errorsItem) {
              res += errorsItem[1].join(', ')
              return res
            }, '')
            const messageText = 'Ошибки.' + errList
            this.showAlert(messageText, 'error', true)
            return
          }
          const messageText = 'Ваша заявка принята на рассмотрение и появится в списке после модерации'
          this.showAlert(messageText, 'success', true)
          this.modalVisible = false
          Vue.ls.set('appEnabled', false, 60000 * 10) // 10 минут
          // setTimeout(() => { this.appEnabled = false }, 6000)
          this.appEnabled = false
        })
        .catch((error) => {
          const errM = error.message ? error.message : ''
          const rspMsg = error.response ? error.response.data.message : ''
          const messageText = 'При отправке вашей заявки произошла ошибка. ' + errM + rspMsg + ' См. консоль'
          this.showAlert(messageText, 'error', true)
          console.log(error)
        })
      console.log('SEND FORM')
      // this.modalVisible = false
    },
    nameChanged (data) {
      if (data && typeof data === 'object') {
        this.item.name = data.data ? data.data.name.full : data.value
        const address = data.data ? data.data.address : (data.subdata ? data.subdata : false)
        if (address) {
          this.addressChanged(address)
          if (typeof address === 'string') {
            this.$refs.addressAutocomplete.changed(address)
            this.$refs.addressAutocomplete.value = address
            this.$refs.addressAutocomplete.searchString = address
          } else {
            this.$refs.addressAutocomplete.value = address.value
            this.$refs.addressAutocomplete.searchString = address.value
          }
        }
      } else if (typeof data === 'string') {
        this.item.name = data
      } else {
        this.item.name = null
      }
    },
    addressChanged (data) {
      if (!data || data === '') {
        this.$refs.addressAutocomplete.value = ''
        this.$refs.addressAutocomplete.searchString = ''
      }
      if (data && typeof data === 'object') {
        this.item.fullAddress = data.unrestricted_value
        this.item.federalDistrict = data.data.federal_district
        this.item.region = data.data.region_with_type
        this.item.city = data.data.city
          ? data.data.city : data.data.settlement_with_type
        this.item.postAddress = data.value
        this.item.fiasId = data.data.fias_id
        this.item.fiasCode = data.data.fias_code
        this.item.kladrId = data.data.kladr_id
        this.item.location.coordinates = [data.data.geo_lon || null, data.data.geo_lat || null]
      } else if (data && typeof data === 'string') {
        this.item.fullAddress = data
        this.item.federalDistrict = null
        this.item.region = null
        this.item.city = null
        this.item.postAddress = null
        this.item.fiasId = null
        this.item.fiasCode = null
        this.item.kladrId = null
        this.item.location.coordinates = []
      } else {
        this.item.fullAddress = null
        this.item.federalDistrict = null
        this.item.region = null
        this.item.city = null
        this.item.postAddress = null
        this.item.fiasId = null
        this.item.fiasCode = null
        this.item.kladrId = null
        this.item.location.coordinates = []
      }
    },
    clearEverything () {
      this.$refs.addressAutocomplete.searchString = ''
      this.$refs.companyAutocomplete.searchString = ''

      // this.$refs.companyAutocomplete.$v.value.$touch()
      // this.$refs.addressAutocomplete.$v.value.$touch()

      this.item.name = null
      this.item.postAddress = null
      this.item.fullAddress = null
      this.item.fiasId = null
      this.item.fiasCode = null
      this.item.kladrId = null
      this.item.location.coordinates = []
      this.item.federalDistrict = null
      this.item.region = null
      this.item.city = null

      this.item.website = null
      this.item.contactSurname = null
      this.item.contactName = null
      this.item.contactLastname = null
      this.item.contactPosition = null
      this.item.contactPhone = null
      this.item.contactEmail = null
      this.item.specializations = null
      this.item.printEquipment = null
      this.item.postprintEquipment = null
    },
    showAlert (text, color, center) {
      this.bottomAlert.alertText = text
      this.bottomAlert.color = color || 'cyan darken-2'
      const c = Boolean(center)
      this.bottomAlert.right = !c
      this.bottomAlert.visible = true
    }
  },
  watch: {
  },
  mounted () {
    let specializationsList = Vue.ls.get('specializationsList')
    if (!specializationsList) {
      backendAxios.get('printers/specializations')
        .then((response) => {
          specializationsList = response.data
          Vue.ls.set('specializationsList', specializationsList, 1000 * 60 * 20)
          this.specializationsList = specializationsList
        })
        .catch((error) => {
          console.log(error)
          this.specializationsList = []

          const errM = error.message ? error.message : ''
          const rspMsg = error.response ? error.response.data.message : ''
          const messageText = 'При получении списка специализаций произошла ошибка. ' + errM + rspMsg + ' См. консоль'
          this.showAlert(messageText, 'error')
        })
    } else {
      this.specializationsList = specializationsList
    }
    const propsToTouch = Object.keys(this.$v.item).filter((key) => { return key.indexOf('$') === -1 })
    for (let k = 0; k < propsToTouch.length; k++) {
      this.$v.item[propsToTouch[k]].$touch()
    }
    let enabled = Vue.ls.get('appEnabled')
    if (enabled === null) {
      enabled = true
      Vue.ls.set('appEnabled', true, 60000 * 10) // 10 минут
    }
    this.appEnabled = enabled
  }
}
</script>
<style scoped lang="scss"></style>
